import { render, staticRenderFns } from "./Outgoing.vue?vue&type=template&id=60ba8ff8&scoped=true&"
import script from "./Outgoing.vue?vue&type=script&lang=ts&"
export * from "./Outgoing.vue?vue&type=script&lang=ts&"
import style0 from "vue-multiselect/dist/vue-multiselect.min.css?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "60ba8ff8",
  null
  
)

export default component.exports